import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useContactStore = defineStore('contact', () => {
    const all = ref(null);
    const active = ref(null);

    const reset = () => {
        all.value = null;
        active.value = null;
    };

    const actions = {
        search: (params) => axios.get('/api/v1/contacts', { params }),
        storeContact: (params) => axios.post('/api/v1/contacts', params),
        updateContact: (params) => axios.patch('/api/v1/contacts/' + params.hash, params),
        qrLookup: (hash, params) => axios.get('/api/v1/contacts/qr/' + hash, { params }),
    };

    return {
        all,
        active,
        reset,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useContactStore.acceptHMRUpdate);
}
